export default {
  onboarding: {
    welcome: {
      title: "Willkommen bei",
      subtitle: "Deine App für Sportwetten-Recherche zu Props, Kombiwetten und Top-Trends. Zeit für das nächste Level.",
      headline: "Finde deine nächste Wette",
      secondaryCta: "Du hast bereits ein Konto? Einloggen",
    },
    leagues: {
      title: "Wähle deine Lieblingsligen",
      subtitle: "Sieh die Ligen, die dir wichtig sind, jedes Mal zuerst, wenn du die App öffnest.",
    },
    location: {
      title: "Sieh, was in deiner Nähe verfügbar ist",
      subtitle: "Aktiviere den Standort, um verfügbare Anbieter und Angebote in deiner Region zu sehen.",
      allowLocationSharing: "Standortfreigabe erlauben",
      orSelectRegion: "oder Region auswählen",
    },
    providers: {
      title: "Wähle deine Anbieter",
      subtitle: "Wähle deine Anbieter für personalisierte Trends, Quoten und eine reibungslosere Betslip-Erfahrung.",
      emptyCta: "Ich habe noch keinen",
    },
    odds: {
      title: "Wähle dein Quotenformat",
      subtitle: "Zeige Quoten in dem Format an, das dir am besten liegt, um schneller und einfacher zu entscheiden.",
    },
    socialProof: {
      title: "Von Wettern überall vertraut",
      subtitle: "Von neuen Nutzern bis zu täglichen Wettern liefert Linemate intelligentere Analysen in großem Maßstab",
      reviewer: "App-Store-Rezensent",
      reviews: {
        review1: {
          title: "Wirklich die am besten gestaltete App, die ich seit Langem gesehen habe.",
          text: "Alles ist genau dort, wo es sein muss, jede Auswahl funktioniert wie erwartet, eine sehr detailliert gestaltete App, die viele Informationen bietet und trotzdem effizient und organisiert ist. Als Statistikfan: großes Lob an Linemate für App-Design und einfache Suche nach starken Picks."
        },
        review2: {
          title: "Beste App von allen",
          text: "Das ist zu 100% die beste App für Sportwetten... nachdem ich sie ein paar Tage ausprobiert hatte, war ich überzeugt. Ich empfehle die kostenpflichtige Version sehr, damit du alles nutzen kannst, was die App bietet... du wirst nicht enttäuscht sein! Lade sie mit Vertrauen herunter und genieße sie!"
        },
        review3: {
          title: "Die beste",
          text: "Ich habe viele Statistik-Apps ausprobiert. Linemate ist die, zu der ich immer zurückkehre. Sie bieten am meisten kostenlos, fügen laufend Funktionen hinzu, ohne etwas wegzunehmen, und der Plus-Plan ist den Preis wert. Der Support antwortete in 5 Minuten. Man merkt, dass sie die Go-to-App sein wollen. Sehr empfehlenswert."
        },
        review4: {
          title: "Positiv überrascht",
          text: "Wenn du neu bist und Props blind folgst, werden die Ergebnisse schwanken; du brauchst trotzdem Strategie. Ich lud Linemate herunter, nachdem meine Kombiwetten immer knapp scheiterten, und meine erste 7-leg Spieler-Prop-Kombiwette traf. Für 10 $/Monat (mit erster Woche gratis) lohnt es sich leicht. Es ist nicht perfekt, aber es erledigt den Großteil der Arbeit."
        },
        review5: {
          title: "Großartige App!",
          text: "Keine Wett-App ist je 100%, aber diese hat mir bisher die besten Ergebnisse geliefert. Alles basiert auf echten Statistiken und Daten. Die kostenlose Version ist stark und das Abo noch besser; du kannst es mit dieser App leicht wieder reinholen."
        },
        review6: {
          title: "Großartige App, die heraussticht",
          text: "Großartige App, die wirklich heraussticht, erschwinglich mit starken Recherchefunktionen. Insgesamt tolle Arbeit, weiter so."
        },
      },
    },
    summary: {
      title: "Dein Profil ist bereit",
      subtitle: "Wir haben die App basierend auf deinen Auswahlmöglichkeiten personalisiert. Erstelle dein Profil, um es zu speichern und loszulegen.",
      leagues: "Deine Ligen",
      location: "Dein Standort",
      oddsFormat: "Dein Quotenformat",
      operators: "Deine Anbieter",
      noOperators: "Keine Anbieter",
    },
    consent: {
      title: "Bleib auf dem Laufenden",
      subtitle: "Erhalte Updates zu Funktionen, Verbesserungen und Angeboten. Du kannst dich jederzeit abmelden.",
      emailToggle: "Updates und exklusive Angebote per E-Mail erhalten",
      pushToggle: "Benachrichtigungen für Echtzeit-Insights aktivieren",
      confirm: "Meine Auswahl bestätigen",
    },
  },
};
